import { render, staticRenderFns } from "./UserContent.vue?vue&type=template&id=387c2eb8&scoped=true"
import script from "./UserContent.vue?vue&type=script&lang=js"
export * from "./UserContent.vue?vue&type=script&lang=js"
import style0 from "./UserContent.vue?vue&type=style&index=0&id=387c2eb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387c2eb8",
  null
  
)

export default component.exports